import { useTranslation } from 'react-i18next';
import useScrollReveal from '@/hooks/useScrollReveal';

const stores = [
  {
    name: 'Walmart',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/84d2f4dd-066f-4226-84d9-9acf6649956d_compressed_Walmart.webp',
  },
  {
    name: 'MasxMenos',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/f46db21f-5289-408b-b356-6f866eb6f33f_compressed_masxmenos.webp',
  },
  {
    name: 'Vindi',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/4637097a-3986-4df7-8334-6fb3e37a0139_compressed_Vindi.webp',
  },
];

export default function LocationsSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="puntos-venta" className="py-24 md:py-32 bg-background-50 relative overflow-hidden">
      {/* Greek decorative element */}
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-[0.04]">
          <div className="w-48 h-72 border-2 border-primary-400 rounded-t-full"></div>
        </div>
        <div className="absolute left-8 bottom-16 opacity-[0.03]">
          <div className="flex gap-2 flex-wrap max-w-[180px]">
            {Array.from({ length: 20 }).map((_, i) => (
              <div key={i} className="w-3 h-3 border border-primary-400 rotate-45"></div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative max-w-[1100px] mx-auto px-6 md:px-10 text-center">

        {/* Heading */}
        <div ref={ref} className={`scroll-reveal mb-16 ${isVisible ? 'visible' : ''}`}>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-5">
            {t('locations.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
            {t('locations.subtitle')}
          </p>
        </div>

        {/* Three store cards */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 md:gap-10 mb-16">
          {stores.map((store, idx) => (
            <div
              key={store.name}
              className={`scroll-reveal group w-full sm:w-[260px] md:w-[280px] flex-shrink-0 ${isVisible ? 'visible' : ''}`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div
                className="relative bg-white rounded-[20px] overflow-hidden transition-all duration-500 cursor-default"
                style={{
                  boxShadow: '0 2px 16px rgba(0,0,0,0.06), 0 1px 4px rgba(0,0,0,0.04)',
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-8px)';
                  (e.currentTarget as HTMLDivElement).style.boxShadow = '0 16px 40px rgba(0,0,0,0.10), 0 4px 12px rgba(0,0,0,0.06)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
                  (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 16px rgba(0,0,0,0.06), 0 1px 4px rgba(0,0,0,0.04)';
                }}
              >
                {/* Logo image container — fixed square aspect for visual consistency */}
                <div className="w-full h-[180px] flex items-center justify-center p-8">
                  <img
                    src={store.imageUrl}
                    alt={store.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* WhatsApp CTA */}
        <a
          href="https://wa.me/50670555703"
          target="_blank"
          rel="noopener noreferrer"
          className="whitespace-nowrap inline-flex items-center gap-2.5 px-8 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 hover:-translate-y-0.5"
          style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.08)' }}
        >
          <i className="ri-whatsapp-line text-base"></i>
          {t('locations.whatsapp')}
        </a>
      </div>
    </section>
  );
}